import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * This does validation of view data items.
 * For the moment no validation is required.
 */
export class TagsDataItem extends AbstractDataItem<DataType.TAGS> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof TagsDataItem.prototype.value ): IValidationError {
        return null;
    }
}
